import React from 'react';
import dayjs from 'dayjs';
import { getEventType } from '../../../../utils/calendar/calendarHelpers';

const MobileEventItem = ({
                             event,
                             onEdit,
                             onDelete,
                             onClick,
                             onEditLock,
                             isLockMode = false
                         }) => {
    // Determine event type and styling
    const eventType = getEventType(event);

    // Map event types to match web calendar styling
    const getEventStyle = () => {
        if (event.bookingCount && event.bookingCount > 0) {
            return {
                background: '#F2A516',
                color: '#FFFFFF',
                borderLeft: '4px solid #D08910'
            };
        }
        if (event.confirmed && event.dogDTO) {
            return {
                background: '#DCF538',
                color: '#15803D',
                borderLeft: '4px solid #B8D919'
            };
        }
        if (event.trainingGroup) {
            return {
                background: '#DC2626',
                color: '#FFFFFF',
                borderLeft: '4px solid #B91C1C'
            };
        }
        if (event.isLocked) {
            return {
                background: event.isTemporary ? '#727272' : '#999999', // Updated colors to match desktop
                color: '#FFFFFF',
                borderLeft: event.isTemporary ? '4px solid #5a5a5a' : '4px solid #808080',
                border: event.isTemporary ? '2px dashed #727272' : 'none'
            };
        }
        return {
            background: '#ACA6FF',
            color: '#FFFFFF',
            borderLeft: '4px solid #928FEE'
        };
    };

    const handleClick = (e) => {
        e.stopPropagation();
        onClick?.(event);
    };

    const style = getEventStyle();
    const startTime = dayjs(event.startTime);
    const endTime = dayjs(event.endTime);

    // Calculate duration in minutes
    const durationMinutes = endTime.diff(startTime, 'minute');
    const isShortEvent = durationMinutes < 60; // Less than 1 hour

    // Render content based on type
    const renderContent = () => {
        if (event.bookingCount && event.bookingCount > 0) {
            return (
                <>
                    <div style={{ fontWeight: '600', fontSize: '14px' }}>Oczekujące</div>
                    <div style={{ fontSize: '12px', opacity: 0.9 }}>
                        Rezerwacje: {event.bookingCount}
                    </div>
                </>
            );
        }

        if (event.confirmed && event.dogDTO) {
            return (
                <>
                    <div style={{ fontWeight: '600', fontSize: '14px' }}>{event.dogDTO.name}</div>
                    {/* UPDATED: Only show time if event is 1 hour or longer */}
                    {!isShortEvent && (
                        <div style={{ fontSize: '12px', opacity: 0.9 }}>{startTime.format('HH:mm')}</div>
                    )}
                </>
            );
        }

        if (event.trainingGroup) {
            return (
                <>
                    <div style={{ fontWeight: '600', fontSize: '14px' }}>{event.trainingGroup.name}</div>
                    {/* UPDATED: Only show time if event is 1 hour or longer */}
                    {!isShortEvent && (
                        <div style={{ fontSize: '12px', opacity: 0.9 }}>{startTime.format('HH:mm')}</div>
                    )}
                </>
            );
        }

        if (event.isLocked) {
            return (
                <>
                    <div style={{ fontWeight: '600', fontSize: '14px' }}>
                        {event.isTemporary ? 'Nowa blokada' : 'Zablokowane'}
                    </div>
                    {/* UPDATED: Only show time range if event is 1 hour or longer */}
                    {!isShortEvent && (
                        <div style={{ fontSize: '12px', opacity: 0.9 }}>
                            {startTime.format('HH:mm')} - {endTime.format('HH:mm')}
                        </div>
                    )}
                </>
            );
        }

        return null;
    };

    // Calculate if we should show action buttons based on height
    const duration = endTime.diff(startTime, 'minute');
    const showActions = duration >= 60; // Show actions only if event is at least 1 hour

    return (
        <div
            style={{
                ...style,
                height: '100%',
                borderRadius: '8px',
                padding: '8px',
                cursor: 'pointer',
                position: 'relative',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                boxSizing: 'border-box',
                transition: 'transform 0.2s, box-shadow 0.2s',
            }}
            onClick={handleClick}
            onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.02)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = 'none';
            }}
        >
            <div>{renderContent()}</div>

            {/* Action buttons - Removed from all events since they're clickable */}
            {/* All events are now clickable to open their respective modals/actions */}
        </div>
    );
};

export default MobileEventItem;